import React from 'react'
import PropTypes from 'prop-types'
import styles from './upgrade-plan-checkout.scss'
import Button from 'src/components/common/Button'
import {
  buildCheckoutURLForPlans,
  getActivePlans,
  getPlanBySlug,
  PlanSlugs,
  PlanType,
  storeUTMDataByKey,
  STRIPE_CHECKOUT_TIMEOUT
} from 'src/services/stripe_checkout_configs'
import CheckoutFrame from '../components/CheckoutFrame'
import MembershipPlanItem from '../components/MembershipPlanItem'
import SvgIcon from 'src/components/common/SvgIcon'
import LeftChevronIcon from 'src/assets/icons/left_chevron.svg'
import GreenCrown from 'src/assets/icons/crown-ico-green.svg'
import PurpleCrown from 'src/assets/icons/crown-ico-purple.svg'
import {
  clearCheckoutPendingResultNode,
  PurchaseWorkflowNode,
  setCheckoutModalOpen,
  setCheckoutPendingResultNode,
  setDefaultWorkflowNode,
  setOpenedTabReference,
  setStripeCheckoutTimeoutHandle
} from '../../../actions/stripeCheckout'
import { isDevMod } from '../../../services/utils'
import { connect } from 'react-redux'
import uuid from 'uuid'

const planTierFilter = (plan, currentPlanConfig) => {
  if (currentPlanConfig?.tier !== undefined) {
    return plan.tier > currentPlanConfig.tier
  } else {
    return true
  }
}

const planMapping = {
  // [PlanSlugs.Free]: 'Basic Plan (Free)',
  [PlanSlugs.EssentialsAnnually]: 'Essentials Subscriber (Annual)',
  [PlanSlugs.EssentialsMonthly]: 'Essentials Subscriber (Month-to-Month)',
  [PlanSlugs.PremiumAnnually]: 'Premium Subscriber'
}

class UpgradePlanCheckout extends React.Component {
  plans = []

  constructor(props) {
    super(props)

    const { currentSub } = this.props
    const currentPlan = getPlanBySlug(currentSub.plan.slug)

    this.plans = getActivePlans().filter(p => {
      return planTierFilter(p, currentPlan)
    })

    this.state = {
      selectedPlan: this.plans[0],
      currentPlanInBackend: currentSub.plan,
      currentPlan
    }
  }

  openStripeCheckoutTab() {
    const { currentSub } = this.props

    const utmCode = uuid.v4()
    storeUTMDataByKey(currentSub, utmCode)
    const href = buildCheckoutURLForPlans(
      this.state.selectedPlan,
      true,
      this.props.user.id,
      utmCode
    )
    const newTabRef = window.open(href, '_blank')
    this.props.setOpenedTabRef(newTabRef)
  }

  render() {
    const {
      setTimeoutHandle,
      storePendingResultNode,
      clearCheckoutPendingResultNode,
      setModalOpen,
      setDefaultCheckoutNode
    } = this.props

    const essentialPlans = this.plans.filter(p => p.planType === PlanType.Essentials)
    const premiumPlans = this.plans.filter(p => p.planType === PlanType.Premium)
    const planGroups = []
    if (essentialPlans.length) {
      planGroups.push({
        title: 'Essentials',
        items: essentialPlans
      })
    }
    if (premiumPlans.length) {
      planGroups.push({
        title: 'Premium',
        items: premiumPlans
      })
    }

    const devMod = isDevMod()

    return (
      <CheckoutFrame
        left={
          <>
            <section className={styles['upgrade-container']}>
              <header className={styles['current-plan-container']}>
                <h1>
                  {this.props.showGoBack && (
                    <SvgIcon
                      divClassName={styles['back-icon']}
                      width={20}
                      height={20}
                      icon={LeftChevronIcon}
                      padding="5px"
                      onClick={() => {
                        if (this.props.onGoBack) {
                          this.props.onGoBack()
                        }
                      }}
                    />
                  )}
                  Upgrade
                </h1>
              </header>

              {this.state.currentPlan.slug !== PlanSlugs.Free && (
                <section className={styles['current-plan-container']}>
                  <p>Your Existing Hobnob Plan:</p>
                  <p className={styles['current-plan-type']}>
                    {planMapping[this.state.currentPlan.slug]}
                  </p>
                </section>
              )}
            </section>
            {planGroups.map((group, planIndex) => {
              return (
                <section className={styles['upgrade-container']} key={planIndex}>
                  <div className={styles['membership-plans']}>
                    <header className={styles['plan-header']}>
                      <SvgIcon
                        icon={group.title === 'Essentials' ? GreenCrown : PurpleCrown}
                        width={24}
                        height={24}
                      />
                      <h1>{group.title}</h1>
                    </header>
                    <section>
                      {group.items.map((plan, itemIndex) => {
                        const isSelectedPlan = plan.stripeId === this.state.selectedPlan.stripeId
                        return (
                          <MembershipPlanItem
                            key={itemIndex}
                            plan={plan}
                            isSelected={isSelectedPlan}
                            theme={group.title === 'Essentials' ? 'green' : 'purple'}
                            isFreeTrailUsed
                            onClick={selectedPlan => {
                              this.setState({ selectedPlan })
                            }}
                          />
                        )
                      })}
                    </section>
                  </div>
                </section>
              )
            })}
            <section className={styles['upgrade-container']}>
              <div className={styles['subscribe-btn-container']}>
                <Button
                  className={styles['subscribe-btn']}
                  purple={this.state.selectedPlan.planType === PlanType.Premium}
                  onClick={() => {
                    this.openStripeCheckoutTab()
                    const nextNode = PurchaseWorkflowNode.PendingMembershipPaymentResult
                    storePendingResultNode(nextNode)
                    setModalOpen(false)
                    const handle = setTimeout(() => {
                      clearCheckoutPendingResultNode()
                      setDefaultCheckoutNode(nextNode)
                      setModalOpen(true)
                    }, STRIPE_CHECKOUT_TIMEOUT)
                    setTimeoutHandle(handle)
                  }}
                >
                  Subscribe
                </Button>
              </div>
              <div className={styles['no-benefit']}>
                <span
                  onClick={() => {
                    this.props.goToCheckoutNode(PurchaseWorkflowNode.NoMembershipFromUpgradePlan)
                  }}
                >
                  No membership benefits
                </span>
              </div>
              {devMod && (
                <Button
                  onClick={() => {
                    this.props.goToCheckoutNode(PurchaseWorkflowNode.TestSubs)
                  }}
                >
                  test subs
                </Button>
              )}
            </section>
          </>
        }
        right={<>{this.state.selectedPlan.detailDescriptionComp()}</>}
      />
    )
  }
}

UpgradePlanCheckout.propTypes = {
  user: PropTypes.object,
  currentSub: PropTypes.object,
  onGoBack: PropTypes.func,
  showGoBack: PropTypes.bool,
  goToCheckoutNode: PropTypes.func,
  setTimeoutHandle: PropTypes.func,
  storePendingResultNode: PropTypes.func,
  clearCheckoutPendingResultNode: PropTypes.func,
  setModalOpen: PropTypes.func,
  setDefaultCheckoutNode: PropTypes.func,
  setOpenedTabRef: PropTypes.func
}

const mapDispatchToProps = dispatch => {
  return {
    setOpenedTabRef: tabRef => {
      dispatch(setOpenedTabReference(tabRef))
    },
    setTimeoutHandle: handle => {
      dispatch(setStripeCheckoutTimeoutHandle(handle))
    },
    storePendingResultNode: pendingResultNode => {
      dispatch(setCheckoutPendingResultNode(pendingResultNode))
    },
    clearCheckoutPendingResultNode: () => {
      dispatch(clearCheckoutPendingResultNode())
    },
    setModalOpen: isOpen => dispatch(setCheckoutModalOpen(isOpen)),
    setDefaultCheckoutNode: node => {
      dispatch(setDefaultWorkflowNode(node))
    }
  }
}

export default connect(null, mapDispatchToProps)(UpgradePlanCheckout)
